import React from "react";
import { AuthService } from "src/auth/auth-service";
import PlanSearchBar from "../fusePlanPage/plan-search-bar";
import {
  Alert,
  Grid,
  Header,
  SpaceBetween,
} from "@amzn/awsui-components-console";
import "src/index.scss";
import PayloadDisplayPlan from "src/lambda/fuseplanServiceLambda/payload-display-plan";
import { Domain } from "src/config/BartLambdaConfig";
import { FullPageTitle } from "src/components/header/title";
import { inputValidation } from "src/commons/input-validation";
import { Auth } from "aws-amplify";
import {
  FuseAccountingCentralDatastoreClient,
  GetPlanCommand,
} from "@amzn/fuse-accounting-central-datastore-client";
import { getFacdConfig } from "src/config/fuse-accounting-central-datastore-config";

export class AppPlan extends React.Component<
  any,
  {
    domain: Domain;
    authenticating: boolean;
    isLoggedIn: boolean;
    show: boolean;
    keyword: string;
    searched: boolean;
    payload: any;
    ldap: string;
    invalidInputs: boolean;
  }
> {
  authObj: AuthService;
  constructor(props: any) {
    super(props);
    this.authObj = new AuthService();
    this.state = {
      domain: this.props.domain,
      authenticating: true,
      isLoggedIn: false,
      show: false,
      keyword: window.location.pathname.split("/")[2] || "",
      searched: false,
      payload: "init",
      ldap: "",
      invalidInputs: false,
    };
    this.setValue = this.setValue.bind(this);
    this.search = this.search.bind(this);
  }

  componentDidMount() {
    const fetchData = async () => {
      // Run authentication
      await this.authObj.authenticate();
      // set loading state to false after authentication completes. This will cause the page to re-render.
      this.setState({
        authenticating: false,
        isLoggedIn: this.authObj.getIsLoggedIn(),
        ldap: this.authObj.ldap,
      });
    };
    fetchData();
    if (this.state.keyword) {
      this.search(this.state.domain);
    }
  }

  setValue(value: string) {
    this.setState({ keyword: value });
  }

  async search(domain: Domain) {
    this.setState({
      invalidInputs: false,
      searched: false,
      payload: "init",
    });
    if (inputValidation(this.state.keyword)) {
      this.setState({
        invalidInputs: true,
      });
    } else {
      this.setState({
        searched: true,
        payload: "init",
      });
      await this.getPlan(domain);
    }
  }

  async getPlan(domain: Domain) {
    try {
      const credentials = await Auth.currentCredentials();
      const essentialCredentials = Auth.essentialCredentials(credentials);

      const facdClient = new FuseAccountingCentralDatastoreClient({
        ...getFacdConfig(domain), // Get the configuration for the domain
        credentials: essentialCredentials, // Pass essential credentials
      });

      const getPlanCommand = new GetPlanCommand({
        planId: this.state.keyword,
      });

      console.log(
        "Starting FACD getPlan operation with getPlanCommand:",
        getPlanCommand,
      );

      const response = await facdClient.send(getPlanCommand);
      console.log("Response received from facdClient:", response);
      this.setState({
        ...this.state,
        payload: response,
      });
    } catch (error: any) {
      console.error("An error occurred in getPlan:", error);
      this.setState({
        ...this.state,
        payload: error.message,
      });
    } finally {
      console.log("Get plan operation completed.");
    }
  }

  render() {
    if (
      !(
        this.state.ldap.includes("bart-read-only") ||
        this.state.ldap.includes("bart-admin")
      )
    ) {
      return (
        <div>
          <FullPageTitle
            title={"Get FusePlan Info"}
            description={"Check the detail of Plan information based on planID"}
          />
          <SpaceBetween size="l" />
          <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
            <Alert
              header="Only authorized users can get plan information!"
              type="error"
            ></Alert>
          </Grid>
        </div>
      );
    }
    return (
      <>
        <FullPageTitle
          title={"Get FusePlan Info"}
          description={"Check the detail of Plan information based on planID"}
        />
        <div className={this.state.searched ? "" : "page"}>
          <SpaceBetween size="l">
            <PlanSearchBar
              keyword={this.state.keyword}
              setValue={this.setValue}
              onClickSearch={this.search}
            />
            {this.state.invalidInputs ? (
              <div>
                <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
                  <Alert
                    header="Invalid input! Plan id field cannot be empty"
                    type="error"
                  ></Alert>
                </Grid>
              </div>
            ) : null}
            {this.state.searched ? (
              <PayloadDisplayPlan
                searchResults={this.state.payload}
                searchId={this.state.keyword}
              />
            ) : null}
          </SpaceBetween>
        </div>
      </>
    );
  }
}

export default AppPlan;
